<template>
  <div :class="componentClassName">
    <slot></slot>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

export default {
  name: 'm-button-container',
  props: {
    class: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: null,
      validator(value) {
        return value.match(/(null|horizontal)/);
      },
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('m-button-container', this.variant);
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
